/**
 * NailDays Landing — Scroll Reveal
 * Elements with class "r" fade in when they enter the viewport.
 * Delay classes: r-d1 (80ms), r-d2 (160ms), r-d3 (240ms)
 * CSS for the animation is in nd-landing.css
 */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.r').forEach(function (el) {
      el.classList.add('v');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('v');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.06, rootMargin: '0px 0px -16px 0px' }
  );

  document.querySelectorAll('.r').forEach(function (el) {
    observer.observe(el);
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('.r:not(.v)').forEach(function (el) {
        observer.observe(el);
      });
    });
  }
})();
